import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import cls from "classnames";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface DialogErrorProps {
  testId?: string;
  onClose: () => void;
  open: boolean;
  onOk: () => void;
  loading?: boolean;
  okText?: string;
  cancelText?: string;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 420,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24,
        color: "#DF044A"
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    btnAction: {
      height: 48
    },
    btnActionSecondary: {
      height: 48,
      "& .Mui-disabled": {
        "& .MuiTypography-root": {
          color: "lightgray !important"
        }
      }
    }
  }),
  { name: "DialogConfirmOrder" }
);

const DialogConfirmOrder: React.FC<DialogErrorProps> = ({
  onClose,
  open,
  onOk,
  loading = false,
  cancelText,
  okText,
  testId
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      data-testid={testId ?? "dialogConfirmSplit"}
      open={open}
      onClose={onClose}
      className={classes.root}
    >
      <DialogTitle>
        <MyTypography variant="h6">
          {intl.formatMessage({ defaultMessage: "บันทึก Split Item" })}
        </MyTypography>
      </DialogTitle>
      <DialogContent>
        <MyTypography variant="body2">
          {intl.formatMessage({
            defaultMessage:
              "กรุณากด “ยืนยัน” เพื่อบันทึกรายการนี้ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
          })}
        </MyTypography>
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          id="cancelSplitOrderItemButton"
          data-testid="cancelSplitOrderItemButton"
          variant="outlined"
          className={cls(classes.btnActionSecondary, "gradient")}
          fullWidth={true}
          onClick={onClose}
          disabled={loading}
        >
          <MyTypography variant="body1">
            {cancelText ? (
              cancelText
            ) : (
              <FormattedMessage defaultMessage="กลับไป" />
            )}
          </MyTypography>
        </Button>
        <Button
          id="confirmSplitOrderItemButton"
          data-testid="confirmSplitOrderItemButton"
          variant="contained"
          className={cls(classes.btnAction, "gradient")}
          fullWidth={true}
          onClick={onOk}
          disabled={loading}
        >
          <MyTypography variant="body1">
            {okText ? okText : <FormattedMessage defaultMessage="ยืนยัน" />}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmOrder;
